<template>
  <div class="preview-wrapper mt-md-0 mt-2">
    <div class="scanner-frame">
      <span class="corner top-left"></span>
      <span class="corner top-right"></span>
      <span class="corner bottom-left"></span>
      <span class="corner bottom-right"></span>

      <img 
        :src="src"
        alt="Document Preview"
        class="preview-image"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PreviewImage",
  props: {
    src: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.preview-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}

.scanner-frame {
  position: relative;
  padding: 25px;
  background: #756f6067;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
}

.preview-image {
  width: 100%;
  max-height: 500px;
  object-fit: contain;
  border-radius: 12px;
}

.corner {
  position: absolute;
  width: 30px;
  height: 30px;
  border: 3px solid #756f60;
}

.top-left {
  top: 15px;
  left: 15px;
  border-right: none;
  border-bottom: none;
}

.top-right {
  top: 15px;
  right: 15px;
  border-left: none;
  border-bottom: none;
}

.bottom-left {
  bottom: 15px;
  left: 15px;
  border-right: none;
  border-top: none;
}

.bottom-right {
  bottom: 15px;
  right: 15px;
  border-left: none;
  border-top: none;
}

@media (max-width: 768px) {
  .preview-image {
    max-height: none;
  }
}

</style>
